import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useParams } from "react-router-dom";
import { APP_NAME, APP_VERSION, CANCEL_REQUEST } from "constants/index";
import {
  Card,
  CardBody,
  Form,
  Row,
  Col,
  Button,
  Space,
  message,
  Empty,
  Spin,
  Input,
  Layout,
} from "antd";
import { UserOutlined, KeyOutlined } from "@ant-design/icons";
import emptyImg from "../assets/img/empty.svg";
import { login, loginStrava } from "redux/actions/auth.action";

const { Header, Content, Footer } = Layout;
const { Password } = Input;
const { Meta } = Card;

const Login = (props) => {
  const dispatch = useDispatch();
  const { ref } = useParams();
  const { isLoggedIn } = useSelector((state) => state.authReducer);
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (isLoggedIn) {
      window.location.replace("/main/overview");
    }

    const ref_id = new URLSearchParams(props.location.search).get("ref");
    if (ref_id) {
      handleLoginStrava(ref_id);
    }
  }, [isLoggedIn, props.location.search]);

  const handleLoginStrava = (user) => {
    setIsLoading(true);
    dispatch(loginStrava(user))
      .then(() => {
        // window.location.reload();
        window.location.replace("/main/overview");
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const handleLogin = () => {
    setIsLoading(true);
    dispatch(login(username, password))
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <main>
        <section id="login">
          <Form onSubmit={handleLogin}>
            <Content className="login-panel">
              <Row justify="space-around" align="middle">
                <Col span={24} offset={0}>
                  <Card
                    title={APP_NAME}
                    bordered={true}
                    className="card-highlight"
                  >
                    <div className="text-center">
                      <Space direction="vertical" size="middle">
                        <Input
                          placeholder="Username"
                          prefix={<UserOutlined />}
                          allowClear
                          onKeyUp={(e) => setUsername(e.target.value)}
                        />
                        <Password
                          placeholder="Password"
                          prefix={<KeyOutlined />}
                          onKeyUp={(e) => setPassword(e.target.value)}
                        />
                        {!isLoading ? (
                          <Button
                            onClick={handleLogin}
                            htmlType="submit"
                            placement="right"
                            type="primary"
                            size="lg"
                            block
                          >
                            <span>Login</span>
                          </Button>
                        ) : (
                          <Empty
                            image={emptyImg}
                            imageStyle={{
                              height: 60,
                            }}
                            description={<span>Loading..</span>}
                          >
                            <Spin />
                          </Empty>
                        )}
                        <a href="/register" type="primary" size="lg" block>
                          Register
                        </a>
                        <a href="http://localhost:8000/auth/strava" type="primary" size="lg" block>
                          Login with Strava
                        </a>
                        <a href="http://localhost:8000/auth/strava/v2" type="primary" size="lg" block>
                          Login with Strava v2
                        </a>
                        <Meta
                          title=""
                          description={`${APP_NAME} v${APP_VERSION} by Brian K © 2023.`}
                        />
                      </Space>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Content>
          </Form>
        </section>
      </main>
    </>
  );
};

export default Login;
